import { HtmlReactParser } from "@kaltura/mediaspace-shared-utils";
import React from "react";
import { BodyText, Title, Wrapper, MailIllustration } from "@kaltura/mediaspace-shared-ui";
import styled from "@emotion/styled";

export interface VerificationCompleteProps {
    completeTitle: string;
    completeDescriptionHtml: string;
}

const ImgWrap = styled.div`
    text-align: center;
`;

export function VerificationComplete({ completeTitle, completeDescriptionHtml }: VerificationCompleteProps) {
    return (
        <Wrapper className="siteRegistration-complete">
            <ImgWrap className={"siteRegistration-complete_image"}>{MailIllustration}</ImgWrap>
            <Title variant={"h2"} component={"h1"} className="siteRegistration-complete_title">
                {completeTitle}
            </Title>
            <BodyText align="center" className="siteRegistration-complete_msg">
                {HtmlReactParser(completeDescriptionHtml)}
            </BodyText>
        </Wrapper>
    );
}

export default VerificationComplete;
